import React, { useState } from 'react'
import ListOfImageListSchema from 'src/components/common/ListOfImageListSchema/ListOfImageListSchema'

import AlignTextFullwidthCarousel from './AlignTextFullwidthCarousel'
import ImagesFullwidthCarousel from './ImagesFullwidthCarousel'

import './fullwidthCarousel.scss'

type TextBlockProps = {
  title: string
  subtitle: string
  btnText: string
  btnBackground: string
  btnColorText: string
  btnBorder: string
  btnLink: string
}
interface Item {
  sources: Sources[]
  alt: string
  href: string
  textBlock: TextBlockProps[]
  promotion: boolean
  campaignEco?: string
  promotionId?: string
  promotionCategory?: string
  promotionName?: string
  promotionPosition?: string
}

function FullwidthCarousel(data: {
  allItems: Item[]
  backgroundbutton: string
  textcolorbutton: string
  autoplay: boolean
  autoplaySpeed: number
  autoplaySpeedSeconds: number
  textAlign?: string
  componentLayout?: string
  desktopSizes: {
    width: number
    height: number
  }
  mobileSizes: {
    width: number
    height: number
  }
}) {
  const [promoViewEventTriggered, setPromoViewEventTriggered] = useState<
    Set<string>
  >(new Set())

  const { allItems } = data
  const [alt, setAltForEvent] = useState('')

  const setPriorityPlaySpeed = () => {
    return data?.autoplaySpeedSeconds
      ? data?.autoplaySpeedSeconds * 1000
      : data?.autoplaySpeed
  }

  const onPromoView = (promotionId: string) => {
    if (!promoViewEventTriggered.has(promotionId)) {
      setPromoViewEventTriggered(
        (prevState) => new Set(prevState.add(promotionId))
      )
    }
  }

  return (
    <>
      {!allItems?.[0]?.textBlock || allItems?.[0]?.textBlock?.length === 0 ? (
        <div className="slider-fullwidthCarousel-container">
          <ImagesFullwidthCarousel
            allItems={allItems}
            alt={alt}
            autoplay={data?.autoplay}
            autoplaySpeed={setPriorityPlaySpeed()}
            backgroundbutton={data?.backgroundbutton}
            textcolorbutton={data?.textcolorbutton}
            setAltForEvent={setAltForEvent}
            onPromoView={onPromoView}
            promoViewEventTriggered={promoViewEventTriggered}
            desktopSizes={data?.desktopSizes}
            mobileSizes={data?.mobileSizes}
          />
        </div>
      ) : (
        <div className="slider-fullwidthCarousel-alignText">
          <AlignTextFullwidthCarousel
            allItems={allItems}
            alt={alt}
            autoplay={data?.autoplay}
            autoplaySpeed={setPriorityPlaySpeed()}
            setAltForEvent={setAltForEvent}
            onPromoView={onPromoView}
            promoViewEventTriggered={promoViewEventTriggered}
            backgroundbutton={data?.backgroundbutton}
            textcolorbutton={data?.textcolorbutton}
            textAlign={data?.textAlign}
            componentLayout={data?.componentLayout}
            desktopSizes={data?.desktopSizes}
            mobileSizes={data?.mobileSizes}
          />
        </div>
      )}
      <ListOfImageListSchema itemList={allItems} name="Full Width Carousel" />
    </>
  )
}

export default FullwidthCarousel
